/** Built-in Class 11 + Class 12 chapter library used by the Add Test chapter picker.
 *  Data only — no scheduling or test logic lives here. Subject values match
 *  SUBJECTS in app-types so downstream logic is unchanged. */

export type SyllabusGroup = {
  /** Section heading shown above the rows, e.g. "Class 11 · Physics". */
  label: string;
  /** Stored subject value (must be one of SUBJECTS). */
  subject: string;
  chapters: string[];
};

const physics11 = [
  "Units and Measurements",
  "Motion in a Straight Line",
  "Motion in a Plane",
  "Laws of Motion",
  "Work, Energy and Power",
  "System of Particles and Rotational Motion",
  "Gravitation",
  "Mechanical Properties of Solids",
  "Mechanical Properties of Fluids",
  "Thermal Properties of Matter",
  "Thermodynamics",
  "Kinetic Theory",
  "Oscillations",
  "Waves",
];

const physics12 = [
  "Electric Charges and Fields",
  "Electrostatic Potential and Capacitance",
  "Current Electricity",
  "Moving Charges and Magnetism",
  "Magnetism and Matter",
  "Electromagnetic Induction",
  "Alternating Current",
  "Electromagnetic Waves",
  "Ray Optics and Optical Instruments",
  "Wave Optics",
  "Dual Nature of Radiation and Matter",
  "Atoms",
  "Nuclei",
  "Semiconductor Electronics",
];

const physicalChem11 = [
  "Some Basic Concepts of Chemistry",
  "Structure of Atom",
  "Classification of Elements and Periodicity",
  "Chemical Bonding and Molecular Structure",
  "States of Matter",
  "Thermodynamics",
  "Equilibrium",
  "Redox Reactions",
];

const inorganicChem11 = [
  "Hydrogen",
  "The s-Block Elements",
  "The p-Block Elements (Group 13 & 14)",
];

const organicChem11 = [
  "Organic Chemistry — Some Basic Principles and Techniques",
  "Hydrocarbons",
];

const physicalChem12 = [
  "Solutions",
  "Electrochemistry",
  "Chemical Kinetics",
  "Surface Chemistry",
  "Solid State",
];

const inorganicChem12 = [
  "The p-Block Elements (Group 15–18)",
  "The d- and f-Block Elements",
  "Coordination Compounds",
];

const organicChem12 = [
  "Haloalkanes and Haloarenes",
  "Alcohols, Phenols and Ethers",
  "Aldehydes, Ketones and Carboxylic Acids",
  "Amines",
  "Biomolecules",
  "Polymers",
  "Chemistry in Everyday Life",
];

const maths11 = [
  "Sets",
  "Relations and Functions",
  "Trigonometric Functions",
  "Complex Numbers and Quadratic Equations",
  "Linear Inequalities",
  "Permutations and Combinations",
  "Binomial Theorem",
  "Sequences and Series",
  "Straight Lines",
  "Conic Sections",
  "Introduction to Three Dimensional Geometry",
  "Limits and Derivatives",
  "Statistics",
  "Probability",
];

const maths12 = [
  "Relations and Functions",
  "Inverse Trigonometric Functions",
  "Matrices",
  "Determinants",
  "Continuity and Differentiability",
  "Application of Derivatives",
  "Integrals",
  "Application of Integrals",
  "Differential Equations",
  "Vector Algebra",
  "Three Dimensional Geometry",
  "Linear Programming",
  "Probability",
];

const biology11 = [
  "The Living World",
  "Biological Classification",
  "Plant Kingdom",
  "Animal Kingdom",
  "Morphology of Flowering Plants",
  "Anatomy of Flowering Plants",
  "Structural Organisation in Animals",
  "Cell: The Unit of Life",
  "Biomolecules",
  "Cell Cycle and Cell Division",
  "Photosynthesis in Higher Plants",
  "Respiration in Plants",
  "Plant Growth and Development",
  "Breathing and Exchange of Gases",
  "Body Fluids and Circulation",
  "Excretory Products and their Elimination",
  "Locomotion and Movement",
  "Neural Control and Coordination",
  "Chemical Coordination and Integration",
];

const biology12 = [
  "Sexual Reproduction in Flowering Plants",
  "Human Reproduction",
  "Reproductive Health",
  "Principles of Inheritance and Variation",
  "Molecular Basis of Inheritance",
  "Evolution",
  "Human Health and Disease",
  "Microbes in Human Welfare",
  "Biotechnology: Principles and Processes",
  "Biotechnology and its Applications",
  "Organisms and Populations",
  "Ecosystem",
  "Biodiversity and Conservation",
];

export const SYLLABUS_GROUPS: SyllabusGroup[] = [
  { label: "Class 11 · Physics", subject: "Physics", chapters: physics11 },
  { label: "Class 11 · Chemistry — Physical", subject: "Chemistry", chapters: physicalChem11 },
  { label: "Class 11 · Chemistry — Organic", subject: "Chemistry", chapters: organicChem11 },
  { label: "Class 11 · Chemistry — Inorganic", subject: "Chemistry", chapters: inorganicChem11 },
  { label: "Class 11 · Mathematics", subject: "Maths", chapters: maths11 },
  { label: "Class 11 · Biology", subject: "Biology", chapters: biology11 },
  { label: "Class 12 · Physics", subject: "Physics", chapters: physics12 },
  { label: "Class 12 · Chemistry — Physical", subject: "Chemistry", chapters: physicalChem12 },
  { label: "Class 12 · Chemistry — Organic", subject: "Chemistry", chapters: organicChem12 },
  { label: "Class 12 · Chemistry — Inorganic", subject: "Chemistry", chapters: inorganicChem12 },
  { label: "Class 12 · Mathematics", subject: "Maths", chapters: maths12 },
  { label: "Class 12 · Biology", subject: "Biology", chapters: biology12 },
];
